import { BrowserRouter } from 'react-router';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { Toaster as Sonner } from '@accio3d/design-system/sonner';
import { TooltipProvider } from '@accio3d/design-system/tooltip';

import { ApiProvider } from './api/query';
import { ApiServicesProvider } from './api/services';
import { AuthProvider } from './hooks/useAuth';
import { OrgChangeRedirect } from './components/org-change-redirect';
import { ThemeProvider, useTheme } from './components/theme-provider';
import { SupplierTermsProvider } from './components/legal/supplier-terms-access';

function ThemedSonner() {
  const { theme } = useTheme();
  return <Sonner theme={theme} />;
}

export function App() {
  return (
    <BrowserRouter>
      <ThemeProvider defaultTheme="light">
        <NuqsAdapter>
          <ApiProvider>
            <AuthProvider>
              <ApiServicesProvider>
                <TooltipProvider>
                  <ThemedSonner />
                  <SupplierTermsProvider>
                    <OrgChangeRedirect />
                  </SupplierTermsProvider>
                </TooltipProvider>
              </ApiServicesProvider>
            </AuthProvider>
          </ApiProvider>
        </NuqsAdapter>
      </ThemeProvider>
    </BrowserRouter>
  );
}
